import gql from "graphql-tag";
import PropTypes from "prop-types";
import {
  format,
  // parse,
  isDate,
  isValid,
} from "date-fns";
// import sortby from "lodash.sortby";

export default {
  query: gql`
    query terminalTransactionsList(
      $sortById: SortField
      $sortByDate: SortField
      $companyId: String
      $merchantId: String
      $terminalId: String
      $dateFrom: DateTime!
      $dateTo: DateTime!
      $pan: String
      $rrn: String
      $authcode: String
      $originType: Int
      $transactionType: Int
      $isSuccessful: Boolean
      $rowFrom: Int
      $rowTo: Int
      $transactionId: ID
    ) {
      terminalTransactions(
        sortById: $sortById
        sortByDate: $sortByDate
        companyId: $companyId
        merchantId: $merchantId
        terminalId: $terminalId
        dateFrom: $dateFrom
        dateTo: $dateTo
        pan: $pan
        rrn: $rrn
        authcode: $authcode
        originType: $originType
        transactionType: $transactionType
        isSuccessful: $isSuccessful
        transactionId: $transactionId
        rowFrom: $rowFrom
        rowTo: $rowTo
      ) {
        id
        transactionId
        date
        type: operationName
        status
        statusName
        responseCode
        isReversal
        hasReversal

        requestAmount
        transactionCurrencyCode
        billingAmount
        fee
        cardCurrencyCode

        paymentSystem
        pan
        originType: transactionType
        ucafIndicator
        posEntryMode

        acquiringId
        acquiringName
        companyId
        companyName
        merchantName
        merchantCountry: country
        terminalId
        device

        authCode
        mcc
        rrn
        ecommerceIndicator

        smsStatus
        smsDate
        smsPhone
        smsText

        currentRow
        totalRows
      }
    }
  `,
  variables: ({
    sortById,
    sortByDate,
    companyId,
    merchantId,
    terminalId,
    dates,
    pan,
    rrn,
    authcode,
    isSuccessful,
    originType,
    transactionType,
    transactionId,
    page = 1,
    itemsPerPage = 10,
  }) => {
    const firstItem = (page - 1) * itemsPerPage || 1;
    const lastItem = firstItem + itemsPerPage;
    const { startDate, endDate } = dates;
    return {
      sortById,
      sortByDate,
      companyId: companyId || undefined,
      merchantId: merchantId || undefined,
      terminalId: terminalId || undefined,
      dateFrom:
        startDate && isDate(startDate) && isValid(startDate)
          ? format(startDate, "YYYY-MM-DDTHH:mm")
          : format(new Date("1970-01-01"), "YYYY-MM-DDTHH:mm"),
      dateTo:
        endDate && isDate(endDate) && isValid(endDate)
          ? format(endDate, "YYYY-MM-DDTHH:mm")
          : format(new Date("2100-01-01"), "YYYY-MM-DDTHH:mm"),
      pan: pan || undefined,
      rrn: rrn || undefined,
      authcode: authcode || undefined,
      isSuccessful:
        typeof isSuccessful === "number" ? !!isSuccessful : undefined,
      originType,
      transactionType,
      transactionId,
      rowFrom: firstItem,
      rowTo: lastItem,
    };
  },
  config: {
    pollInterval: 0,
    errorPolicy: "none",
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  },
  propTypes: {
    companyId: PropTypes.string,
    merchantId: PropTypes.string,
    terminalId: PropTypes.string,
    dateFrom: PropTypes.instanceOf(Date),
    dateTo: PropTypes.instanceOf(Date),
    pan: PropTypes.string,
    rrn: PropTypes.string,
    authcode: PropTypes.string,
    transactionType: PropTypes.number,
    page: PropTypes.number,
    itemsPerPage: PropTypes.number,
  },
  dataKey: "terminalTransactions",
  // sort: (items) =>
  //   sortby(sortby(items, (o) => parseInt(o.id, 10)).reverse(), (o) =>
  //     parse(o.date)
  //   ).reverse(),
  getTotal: (items) => (items && items.length ? items[0].totalRows : null),
};



// WEBPACK FOOTER //
// ./src/model/gql/queries/terminalTransactions.js